import { render, staticRenderFns } from "./SearchResultTabsEvents.vue?vue&type=template&id=672f8bf9&"
import script from "./SearchResultTabsEvents.vue?vue&type=script&lang=js&"
export * from "./SearchResultTabsEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports